<template>
  <v-autocomplete
    hide-details="auto"
    :items="shops"
    :loading="loading"
    v-model="filterDatas.fromShop"
    item-text="name"
    item-value="id"
    label="From Shop"
    clearable
    outlined
    dense
    @change="emitInput(filterDatas.fromShop)"
    :search-input.sync="searchShop"
  ></v-autocomplete>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
    DefaultShopVisble: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    shops: [],
    selectedShop: null,
    searchShop: null,
    loading: false,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_FROM_SHOP_FILTER', data);
      this.$emit('input', this.filterDatas.fromShop);
    },
    getShopByQuery(query = '') {
      this.loading = true;
      this.$store
        .dispatch('shop/GetShop', {
          query: this.filterDatas.fromShopquery
            ? this.filterDatas.fromShopquery
            : query,

          status: 'active',
        })
        .then((res) => {
          this.shops = res;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectedShop = null;
      },
      deep: true,
    },
    searchShop: {
      handler(val) {
        this.$store.commit('UPDATE_FROM_SHOP_QUERY_FILTER', val);

        this.getShopByQuery(val);
      },
      deep: true,
    },
  },
  created() {
    if (this.DefaultShopVisble) {
      this.selectedShop = null;
    }
    this.$emit('input', this.filterDatas.fromShop);

    this.getShopByQuery();
  },
};
</script>
